import { unifiedTechnologiesFilterModule } from '@core/modules/digital-footprint/technologies/technologies.unified.filters'
import { useUnifiedFilter } from '@core/hooks/useUnifiedFilter'
import { useTechnologiesWithIssues } from '@routes/digital-footprint/routes/technologies/hooks/useTechnologiesWithIssues'
import SearchFilterSection from '@/ui/components/searchFilterSection/SearchFilterSection'

const TechnologiesHeader = () => {
    const { technologiesWithIssues } = useTechnologiesWithIssues()

    const {
        search,
        filterConfig,
        data: filteredTechnologies,
        handleFilterChange,
        handleSearchChange,
        handleFilterReset,
        getFilterOptions,
        activeFilters,
    } = useUnifiedFilter({
        filterModule: unifiedTechnologiesFilterModule,
        data: technologiesWithIssues,
    })

    return (
        <SearchFilterSection
            allItems={technologiesWithIssues}
            filteredItems={filteredTechnologies}
            onSearchChange={handleSearchChange}
            onFilterChange={handleFilterChange}
            getFilterOptions={getFilterOptions}
            filterConfig={filterConfig}
            searchValue={search}
            activeFilters={activeFilters}
            searchPlaceholder="Search technologies..."
            itemLabel="technologies"
            onFilterReset={handleFilterReset}
        />
    )
}

export default TechnologiesHeader
